import {
	Component,
	DoCheck,
	Input,
	OnInit,
	TemplateRef,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import { OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { OverlayService } from 'src/app/core/services/overlay.service';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-progress-spinner',
	templateUrl: './progress-spinner.component.html',
	styleUrls: []
})
export class ProgressSpinnerComponent implements OnInit, DoCheck {
	/** Spinner config */
	color?: ThemePalette = 'primary';
	diameter?: number = 100;
	mode: ProgressSpinnerMode = 'indeterminate';
	backdropEnabled = true;
	positionGloballyCenter = true;

	@Input() displayProgressSpinner: boolean | null;

	@ViewChild('progressSpinnerRef', { read: TemplateRef, static: true })
	private progressSpinnerRef!: TemplateRef<any>;
	private progressSpinnerOverlayConfig!: OverlayConfig;
	private overlayRef!: OverlayRef;

	constructor(
		private vcRef: ViewContainerRef,
		private overlayService: OverlayService
	) {}

	ngOnInit() {
		/** Config for Overlay Service */
		this.progressSpinnerOverlayConfig = {
			hasBackdrop: this.backdropEnabled
		};

		if (this.positionGloballyCenter) {
			this.progressSpinnerOverlayConfig['positionStrategy'] =
				this.overlayService.positionGloballyCenter();
		}

		/** Create Overlay for progress spinner */
		this.overlayRef = this.overlayService.createOverlay(
			this.progressSpinnerOverlayConfig
		);
	}

	ngDoCheck() {
		/** Based on status of displayProgressSpinner attach/detach overlay to progress spinner template */
		if (this.displayProgressSpinner && !this.overlayRef.hasAttached()) {
			this.overlayService.attachTemplatePortal(
				this.overlayRef,
				this.progressSpinnerRef,
				this.vcRef
			);
		} else if (!this.displayProgressSpinner && this.overlayRef.hasAttached()) {
			this.overlayRef.detach();
		}
	}
}
